import { Icon } from 'vopay';
import styles from './ExpandToggle.module.scss';

export default function ExpandToggle({
  expanded,
  onClick,
}: {
  expanded: boolean;
  onClick: (newState: boolean) => void;
}) {
  return (
    <div
      aria-hidden="true"
      data-testid="expandToggle"
      data-expanded={expanded}
      onClick={() => {
        onClick(!expanded);
      }}
      className={styles.expandToggleContainer}
    >
      <Icon position="left" icon={expanded ? 'angleTop' : 'angleDown2'} width="16px" height="16px" />
    </div>
  );
}
